<!--幼儿园资源-->
<template>
    <div class="yey-home-container">
        <div class="yey-container" v-show="this.showMode==='homePage'">
            <div class="museum-title-container">
                <div class="l-museum-title-container">
                    <div class="l-t-museum-title-container">幼儿园资源</div>
                    <div class="l-b-museum-title-container">素材中心</div>
                </div>
                <div class="r-museum-title-container">
                </div>
            </div>

            <div class="home-img-container" style="padding-bottom: 30px;">
                    <div class="home-line-container">
                        <div class="home-line-item" @click="jumpScModel('英雄模范')">
                            <img class="line-img-100" src="../../assets/bymy/英雄模范.png" alt="英雄模范">
                        </div>
                        <div class="home-line-item" @click="viewKxjMode">
                            <img class="line-img-100" src="../../assets/bymy/中国科学家榜样.png" alt="中国科学家榜样">
                        </div>
                        <div class="home-line-item" @click="jumpScModel('伟人诗词')">
                            <img class="line-img-100" src="../../assets/bymy/伟人诗词.png" alt="伟人诗词">
                        </div>
                        <div class="home-line-item" @click="jumpScModel('中华美德')">
                            <img class="line-img-100" src="../../assets/bymy/中华美德.png" alt="中华美德">
                        </div>
                    </div>

                    <div class="home-line-container">
                        <div class="home-line-item " @click="jumpScModel('德育名篇')">
                            <img class="line-img-100" src="../../assets/bymy/德育名篇.png" alt="德育名篇">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('爱国歌曲')">
                            <img class="line-img-100" src="../../assets/bymy/爱国歌曲.png" alt="爱国歌曲">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('和你读诗')">
                            <img class="line-img-100" src="../../assets/bymy/和你读诗.png" alt="和你读诗">
                        </div>
                        <div class="home-line-item" @click="jumpScModel('经典美文')">
                            <img class="line-img-100" src="../../assets/bymy/经典美文.png" alt="经典美文">
                        </div>
                    </div>
                    <div class="home-line-container">
                        <div class="home-line-item " @click="jumpScModel('成语典故')">
                            <img class="line-img-100" src="../../assets/bymy/成语典故.png" alt="成语典故">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('诗文素养')">
                            <img class="line-img-100" src="../../assets/bymy/诗文素养.png" alt="诗文素养">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('诗词赏析')">
                            <img class="line-img-100" src="../../assets/bymy/诗词赏析.png" alt="诗词赏析">
                        </div>
                        <div class="home-line-item" @click="jumpScModel('诗词诵读')">
                            <img class="line-img-100" src="../../assets/bymy/诗词诵读.png" alt="诗词诵读">
                        </div>

                    </div>

                    <div class="home-line-container">
                        <div class="home-line-item " @click="jumpScModel('古诗吟唱')">
                            <img class="line-img-100" src="../../assets/bymy/古诗吟唱.png" alt="古诗吟唱">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('以美润心')">
                            <img class="line-img-100" src="../../assets/bymy/以美润心.png" alt="以美润心">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('世界名曲')">
                            <img class="line-img-100" src="../../assets/bymy/世界名曲.png" alt="世界名曲">
                        </div>
                        <div class="home-line-item" @click="jumpScModel('经典童谣')">
                            <img class="line-img-100" src="../../assets/bymy/经典童谣.png" alt="经典童谣">
                        </div>

                    </div>

                    <div class="home-line-container">
                        <div class="home-line-item " @click="jumpScModel('唱游数学')">
                            <img class="line-img-100" src="../../assets/bymy/唱游数学.png" alt="唱游数学">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('民间体育')">
                            <img class="line-img-100" src="../../assets/bymy/以美健体.png" alt="以美健体">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('绕口令')">
                            <img class="line-img-100" src="../../assets/bymy/绕口令.png" alt="绕口令">
                        </div>
                        <div class="home-line-item" @click="jumpScModel('颜色系列')">
                            <img class="line-img-100" src="../../assets/bymy/颜色系列.png" alt="颜色系列">
                        </div>

                    </div>

                    <div class="home-line-container">
                        <div class="home-line-item " @click="jumpScModel('线条形状系列')">
                            <img class="line-img-100" src="../../assets/bymy/线条形状系列.png" alt="线条形状系列">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('东方艺术系列')">
                            <img class="line-img-100" src="../../assets/bymy/东方艺术系列.png" alt="东方艺术系列">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('经典大师系列')">
                            <img class="line-img-100" src="../../assets/bymy/经典大师系列.png" alt="经典大师系列">
                        </div>
                        <div class="home-line-item" @click="jumpScModel('人文艺术系列')">
                            <img class="line-img-100" src="../../assets/bymy/人文艺术系列.png" alt="人文艺术系列">
                        </div>

                    </div>

                    <div class="home-line-container">
                        <div class="home-line-item " @click="jumpScModel('生活常识系列')">
                            <img class="line-img-100" src="../../assets/bymy/生活常识系列.png" alt="生活常识系列">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('中国建筑构造系列')">
                            <img class="line-img-100" src="../../assets/bymy/中国古建筑系列.png" alt="中国古建筑系列">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('中国建筑名胜系列')">
                            <img class="line-img-100" src="../../assets/bymy/中国建筑名胜系列.png" alt="中国建筑名胜系列">
                        </div>
                        <div class="home-line-item" @click="jumpScModel('中国传统民居系列')">
                            <img class="line-img-100" src="../../assets/bymy/中国传统民居系列.png" alt="中国传统民居系列">
                        </div>

                    </div>

                    <div class="home-line-container" >
                        <div class="home-line-item " @click="jumpScModel('西方经典建筑系列')">
                            <img class="line-img-100" src="../../assets/bymy/世界经典建筑系列.png" alt="世界经典建筑系列">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('交通工具系列')">
                            <img class="line-img-100" src="../../assets/bymy/交通工具系列.png" alt="交通工具系列">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('自然气象系列')">
                            <img class="line-img-100" src="../../assets/bymy/自然气象系列.png" alt="自然气象系列">
                        </div>
                        <div class="home-line-item" @click="jumpScModel('传统美食系列')">
                            <img class="line-img-100" src="../../assets/bymy/传统美食系列.png" alt="传统美食系列">
                        </div>

                    </div>

                    <div class="home-line-container">
                        <div class="home-line-item " @click="jumpScModel('传统乐器系列')">
                            <img class="line-img-100" src="../../assets/bymy/传统乐器系列.png" alt="传统乐器系列">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('水果蔬菜系列')">
                            <img class="line-img-100" src="../../assets/bymy/水果蔬菜系列.png" alt="水果蔬菜系列">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('植物花卉系列')">
                            <img class="line-img-100" src="../../assets/bymy/花卉植物系列.png" alt="花卉植物系列">
                        </div>
                        <div class="home-line-item" @click="jumpScModel('动物昆虫系列')">
                            <img class="line-img-100" src="../../assets/bymy/动物昆虫系列.png" alt="动物昆虫系列">
                        </div>

                    </div>

                    <div class="home-line-container">
                        <div class="home-line-item " @click="jumpScModel('四大发明系列')">
                            <img class="line-img-100" src="../../assets/bymy/四大发明系列.png" alt="四大发明系列">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('科学艺术系列')">
                            <img class="line-img-100" src="../../assets/bymy/科学艺术系列.png" alt="科学艺术系列">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('传统节日系列')">
                            <img class="line-img-100" src="../../assets/bymy/传统节日系列.png" alt="传统节日系列">
                        </div>
                        <div class="home-line-item" @click="jumpScModel('其他节日系列')">
                            <img class="line-img-100" src="../../assets/bymy/其他节日系列.png" alt="其他节日系列">
                        </div>

                    </div>

                    <div class="home-line-container">
                        <div class="home-line-item " @click="jumpScModel('二十四节气系列')">
                            <img class="line-img-100" src="../../assets/bymy/二十四节气系列.png" alt="二十四节气系列">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('人体奥秘系列')">
                            <img class="line-img-100" src="../../assets/bymy/人体奥秘系列.png" alt="人体奥秘系列">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('四季系列')">
                            <img class="line-img-100" src="../../assets/bymy/四季系列.png" alt="四季系列">
                        </div>
                        <div class="home-line-item" @click="jumpScModel('花样时光系列')">
                            <img class="line-img-100" src="../../assets/bymy/花样时光系列.png" alt="花样时光系列">
                        </div>

                    </div>

                    <div class="home-line-container">
                        <div class="home-line-item " @click="jumpScModel('东方神韵系列')">
                            <img class="line-img-100" src="../../assets/bymy/东方神韵系列.png" alt="东方神韵系列">
                        </div>
                        <div class="home-line-item " @click="jumpScModel('珍禽异兽系列')">
                            <img class="line-img-100" src="../../assets/bymy/珍禽异兽系列.png" alt="珍禽异兽系列">
                        </div>
                        <div class="home-line-item" @click="jumpScModel('章服之美')">
                            <img class="line-img-100" src="../../assets/bymy/章服之美.png" alt="章服之美">
                        </div>
                    </div>
                </div>
        </div>

        <!--视频播放-->
        <div class="video-play-container" v-show="this.showMode === this.videoPage">
            <hum-video-player :video-id="this.videoId"
                              @change-home-mode="changeHomeMode"/>
        </div>

        <!--  中国科学家榜样  -->
        <div  v-show="this.showMode === this.kxjPage">
            <hum-kxj-mode @change-home-mode="changeHomeMode"/>
        </div>

        <!-- 模块视频列表 -->
        <div  v-show="this.showMode === this.vListPage">
            <hum-video-list-mode :cname="this.categoryName"
                                 @list-play-video="listPlayVideo"
                                 @change-home-mode="changeHomeMode"/>
        </div>
    </div>
</template>
<script>
import humVideoListMode from "@/components/home/humVideoListMode.vue";
import humVideoPlayer from "@/components/home/humVideoPlayer.vue";
import humKxjMode from "@/components/home/humKxjMode.vue";
import {serviceUrl} from "@/utils/global";

export default {
    name: "yeyResourceHome",
    components: {humVideoListMode,humVideoPlayer,humKxjMode},
    props:{

    },
    watch:{

    },
    data() {
        return {
            showMode:"homePage", // 显示模块
            lastMode:"", // 上次显示模块
            homePage:"homePage", // 主页
            videoPage:"videoPage", // 播放视频
            kxjPage:"kxjPage", // 播放视频
            vListPage:"vListPage", // 播放视频
            markInfo:'time-',
            activePath: "welHome",
            serviceUrl,
            // 视频列表
            videoId:'',
            videoList:[],
            // 视频列表
            categoryName:'',
        }
    },
    computed: {},
    created() {

    },
    mounted(){},
    methods: {
        // 查看模块
        jumpScModel(cname){
            this.categoryName = cname+"&"+Math.random();
            this.lastMode = this.showMode;
            this.showMode = this.vListPage;
        },
        // 查看科学家
        viewKxjMode(){
            this.lastMode = this.showMode;
            this.showMode = this.kxjPage;
        },
        // 列表播放
        listPlayVideo(vid){
            //参数传递
            this.videoId = vid+"&"+Math.random();
            this.lastMode = this.vListPage;
            this.showMode = this.videoPage;
        },
        changeHomeMode(lm){
            if (lm){
                this.showMode = lm;
            }else {
                this.showMode = this.lastMode;
            }

        },
    }
}
</script>
<style>
.yey-home-container{
    width: 100%;
    height: auto;
}
.yey-container{
    width: 100%;
    height: auto;
    background-color: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.museum-title-container{
    width: 100%;
    height: 70px;
    display: flex;
    padding: 0 20px 0 20px;
    box-sizing: border-box;
}
.l-museum-title-container{
    width: calc(100% - 80px);
    height: 70px;
}
.l-t-museum-title-container{
    width: 100%;
    height: 40px;
    font-weight: bold;
    color: #0d55a4;
    font-size: 17px;
    line-height: 50px;
}
.l-b-museum-title-container{
    width: 100%;
    height: 30px;
    color: #9a9a9a;
    font-size: 14px;
}
.r-museum-title-container{
    width: 80px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.back-btn-container{
    width: 80px;
    height: 32px;
    background: #0d55a4;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 15px;
    border-radius: 6px;
    letter-spacing: 3px;
    cursor: pointer;
}


.home-img-container{
    width: 100%;
    height: auto;
    padding: 0 20px 0 20px;
    box-sizing: border-box;
}
.home-line-container{
    width: 100%;
    height: auto;
    display: flex;
    margin-bottom: 30px;
    gap: 10px;
}
.home-line-item{
    width: 25%;
    height: auto;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .04);
    cursor: pointer;
}
.line-img-100{
    width: 100%;
    height: 100%;
    border-radius: 8px;
}
</style>